"use client";

import { c as _c } from "react/compiler-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { SingleProviderSelect } from "@/components/provider-select";
export default function PreferredProviderField(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const {
    control,
    formState: t1
  } = useFormContext();
  const {
    errors
  } = t1;
  const errorMessage = errors.preferredProviderId?.message as string | undefined;
  let t2;
  if ($[0] !== errorMessage) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <SingleProviderSelect className="mt-1" triggerId="preferredProviderId" value={field.value || undefined} onValueChange={field.onChange} hasError={!!errorMessage} />;
    };
    $[0] = errorMessage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== control || $[3] !== t2) {
    t3 = <Controller name="preferredProviderId" control={control} render={t2} />;
    $[2] = control;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== errorMessage) {
    t4 = errorMessage && <p className="mt-1 text-caption text-status-error-text">{errorMessage}</p>;
    $[5] = errorMessage;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className={className}>{t3}{t4}</div>;
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}